export default {
    signInForm: false,
    signUpForm: false,
    profileForm: false,
    recoverPasswordForm: false,
    resetPasswordForm: false,
    settingsForm: false,
    selectPictureForm: false,
    notificationsList: false,
    notificationToast: {
        visible: false,
        id: 0,
    },
    noInternet: false,
    previousRouteName: 'home',
};



// WEBPACK FOOTER //
// ./src/store/modules/navbar/state.js